<div class="country-field-requirements" *ngIf="showRequirements">
    <ng-container *ngIf="hasMissingFields; else allComplete">
        <div class="requirement-group" *ngFor="let group of missingFieldGroups">
            <span class="group-label" [ngClass]="levelClass(group.level)">{{ group.level }}</span>
            <ul class="group-fields">
                <li *ngFor="let field of group.fields">{{ field.label }}</li>
            </ul>
        </div>
    </ng-container>
    <ng-template #allComplete>
        <span class="all-complete">All fields have been populated.</span>
    </ng-template>

    <div class="extra-inputs" *ngIf="config?.requiresUaeCitizenship || config?.requiresNewZealandVersion || config?.requiresTanzaniaIssueDate">
        <mat-form-field class="extra-input" *ngIf="config?.requiresUaeCitizenship">
            <mat-label>Citizenship</mat-label>
            <input matInput [matAutocomplete]="citizenshipAuto" [(ngModel)]="contact.citizenship" [required]="!!config?.requiresUaeCitizenship" [attr.aria-invalid]="isCitizenshipInvalid" (focus)="onCitizenshipFocus()" (input)="onCitizenshipInput()" />
            <mat-autocomplete #citizenshipAuto="matAutocomplete">
                <mat-option *ngFor="let code of filteredCitizenshipCodes" [value]="code.apiInputCode">{{ code.countryName }}</mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isCitizenshipInvalid">Select a citizenship from the list</mat-error>
        </mat-form-field>

        <mat-form-field class="extra-input extra-field" *ngIf="config?.requiresNewZealandVersion">
            <mat-label>Driving Licence Version</mat-label>
            <input matInput [(ngModel)]="contact.drivingLicenceVersion" [required]="isDrivingLicenceVersionRequired" />
        </mat-form-field>

        <mat-form-field class="extra-input extra-field" *ngIf="config?.requiresTanzaniaIssueDate">
            <mat-label>National ID Issue Date</mat-label>
            <input matInput [matDatepicker]="issueDatePicker" [ngModel]="issueDate" [max]="maxIssueDate" [required]="isNationalIdIssueDateRequired" (dateChange)="onIssueDateChange($event)" />
            <mat-datepicker-toggle matIconSuffix [for]="issueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #issueDatePicker></mat-datepicker>
        </mat-form-field>
    </div>
</div>
